import React from 'react';
import { Outlet } from 'react-router-dom';

export const ClinicPageLayout: React.FC = () => {
  return <Outlet />;
};

export default ClinicPageLayout;
